export const useReportPage = window.location.href.includes('/generate-report/');

export const useESGReportPage = window.location.href.includes('/generate-report/esg');
